import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

/** Column type UUIDs — match vos-types ProductCatalogueTemplateAdditionalColumnType. */
export const PRODUCT_CATALOGUE_TEMPLATE_COLUMN_TYPE_TEXT = "ef46fdb3-34d5-418a-8382-ff6b2f18649f";
export const PRODUCT_CATALOGUE_TEMPLATE_COLUMN_TYPE_NUMBER = "61ec7adb-4554-4271-957f-9394ace09539";
export const PRODUCT_CATALOGUE_TEMPLATE_COLUMN_TYPE_UUID = "0b45d4dd-1cfb-4bfb-8fb4-7ce04d38cbd2";

/** Preferred template IDs (display-name fallback also accepted when Bruno uses workspace-specific IDs). */
export const OTTOKART_CATEGORY_TEMPLATE_ID = "b3c4d5e6-f7a8-4901-bc23-de4567890a01" as Uuid;
export const OTTOKART_BRAND_TEMPLATE_ID = "b3c4d5e6-f7a8-4901-bc23-de4567890a02" as Uuid;
export const OTTOKART_PRODUCT_TEMPLATE_ID = "b3c4d5e6-f7a8-4901-bc23-de4567890a03" as Uuid;
export const OTTOKART_PRODUCT_TYPE_TEMPLATE_ID = "b3c4d5e6-f7a8-4901-bc23-de4567890a04" as Uuid;
export const OTTOKART_EQUIPMENT_MANUFACTURER_TEMPLATE_ID = "b3c4d5e6-f7a8-4901-bc23-de4567890a05" as Uuid;
export const OTTOKART_OEM_PART_TEMPLATE_ID = "b3c4d5e6-f7a8-4901-bc23-de4567890a06" as Uuid;
export const OTTOKART_MACHINE_TYPE_TEMPLATE_ID = "b3c4d5e6-f7a8-4901-bc23-de4567890a07" as Uuid;

/** Product template column ids — must match create-product-template-full.bru */
export const OTTOKART_PRODUCT_DISPLAY_NAME_COLUMN_ID = "ca0b7a5e-f1f3-430d-9452-aea667da4ecc" as Uuid;
export const OTTOKART_PRODUCT_SLUG_COLUMN_ID = "3d1d89c7-d803-49d1-bba7-5b9901763f46" as Uuid;
export const OTTOKART_PRODUCT_SKU_COLUMN_ID = "32f84384-0933-48c4-9a9c-a0dc2472e17f" as Uuid;
export const OTTOKART_PRODUCT_PRICE_COLUMN_ID = "25516490-e3f3-4f28-bf9d-90cebeb0d1c2" as Uuid;
export const OTTOKART_PRODUCT_CATEGORY_ID_COLUMN_ID = "db20df57-9959-49d0-818b-a39d170188b1" as Uuid;
export const OTTOKART_PRODUCT_BRAND_ID_COLUMN_ID = "e7b15638-d5e5-40b2-942b-45d673cc0ba1" as Uuid;
export const OTTOKART_PRODUCT_DESCRIPTION_COLUMN_ID = "ca25ad81-8c84-419e-9e99-cdee90c60a60" as Uuid;
export const OTTOKART_PRODUCT_TYPE_ID_COLUMN_ID = "c1d2e3f4-a5b6-4789-a012-3456789d0105" as Uuid;

/** Product template column — JSON array of OEM Part Reference catalogue row ids on variant rows. */
export const OTTOKART_PRODUCT_EQUIVALENT_OEM_PART_IDS_COLUMN_ID = "9f982145-3789-4998-a178-31800f360071" as Uuid;

/** Product template column — JSON array of media library dirent ids for product/variant images. */
export const OTTOKART_PRODUCT_IMAGE_IDS_COLUMN_ID = "a8b9c0d1-e2f3-4789-a234-567890abcdef" as Uuid;

/** Variant-only product template columns — populated on child variant rows (Tuffex migration). */
export const OTTOKART_PRODUCT_MRP_COLUMN_ID = "b1c2d3e4-f5a6-4789-b012-3456789abc01" as Uuid;
export const OTTOKART_PRODUCT_HSN_CODE_COLUMN_ID = "b1c2d3e4-f5a6-4789-a012-3456789abc02" as Uuid;
export const OTTOKART_PRODUCT_IS_INCLUSIVE_ALL_TAXES_COLUMN_ID = "b1c2d3e4-f5a6-4789-b012-3456789abc03" as Uuid;
export const OTTOKART_PRODUCT_ATTRIBUTE_VALUES_COLUMN_ID = "b1c2d3e4-f5a6-4789-a012-3456789abc04" as Uuid;
export const OTTOKART_PRODUCT_ADDITIONAL_DETAILS_COLUMN_ID = "b1c2d3e4-f5a6-4789-a012-3456789abc05" as Uuid;
/** Parent product rows — JSON array of workspace variant attribute type ids. */
export const OTTOKART_PRODUCT_VARIANT_ATTRIBUTE_IDS_COLUMN_ID = "b1c2d3e4-f5a6-4789-a012-3456789abc06" as Uuid;

/** Brand / category lookup display-name columns — must match Pluto Ottokart catalogue setup. */
export const OTTOKART_BRAND_DISPLAY_NAME_COLUMN_ID = "08aea53f-c0af-4665-bbce-19de63148174" as Uuid;
export const OTTOKART_CATEGORY_DISPLAY_NAME_COLUMN_ID = "12a186d7-359b-4388-8e60-f093770f4275" as Uuid;

/** OEM Part Reference template column ids — must match create-ottokart-oem-part-template.bru */
export const OTTOKART_OEM_PART_DISPLAY_NAME_COLUMN_ID = "6d659812-0456-4f65-bf55-0f577c03774f" as Uuid;
export const OTTOKART_OEM_PART_CODE_COLUMN_ID = "7e760923-1567-4776-8f66-1f688d14885f" as Uuid;
export const OTTOKART_OEM_PART_MANUFACTURER_ID_COLUMN_ID = "8f871034-2678-4887-9067-20799e259960" as Uuid;

/** Legacy single-template Ottokart setup (SKU + price only) — still accepted as product template fallback. */
export const OTTOKART_LEGACY_PRODUCT_TEMPLATE_ID = "4676ed15-a974-4d7d-bf6e-68818b3ff26f" as Uuid;

export const OTTOKART_CATEGORY_TEMPLATE_DISPLAY_NAME = "Ottokart Category";
export const OTTOKART_BRAND_TEMPLATE_DISPLAY_NAME = "Ottokart Brand";
export const OTTOKART_PRODUCT_TEMPLATE_DISPLAY_NAME = "Ottokart Product";
export const OTTOKART_PRODUCT_TYPE_TEMPLATE_DISPLAY_NAME = "Ottokart Product Type";
export const OTTOKART_EQUIPMENT_MANUFACTURER_TEMPLATE_DISPLAY_NAME = "Ottokart Equipment Manufacturer";
export const OTTOKART_OEM_PART_TEMPLATE_DISPLAY_NAME = "Ottokart OEM Part Reference";
export const OTTOKART_MACHINE_TYPE_TEMPLATE_DISPLAY_NAME = "Ottokart Machine Type";

/** Fitment node type for admin machine (equipment model) rows. */
export const OTTOKART_ADMIN_MACHINE_FITMENT_NODE_TYPE = "MODEL";

export const OTTOKART_CATALOGUE_SETUP_HINT =
    "Run Bruno 00-setup (Category, Brand, Product, Product Type, Equipment Manufacturer, OEM Part, and Machine Type templates) for this workspace.";

export const OTTOKART_EQUIPMENT_MANUFACTURER_SETUP_HINT =
    "Run Bruno 00-setup/create-ottokart-equipment-manufacturer-template.bru for this workspace.";

export const OTTOKART_OEM_PART_SETUP_HINT =
    "Run Bruno 00-setup/create-ottokart-oem-part-template.bru for this workspace.";

export const OTTOKART_PRODUCT_TYPE_SETUP_HINT =
    "Run Bruno 00-setup/create-ottokart-product-type-template.bru for this workspace.";

export const OTTOKART_MACHINE_TYPE_SETUP_HINT =
    "Run Bruno 00-setup/create-ottokart-machine-type-template.bru for this workspace.";

export const OTTOKART_FITMENT_SETUP_HINT =
    "Run Bruno 00-setup provision-fitment + enable-fitment (or enable-ottokart) for this workspace.";
